import React, { Suspense, lazy ,useEffect, useRef,useState  } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import NotFound from "./pages/NotFound";
import Footer from './pages/Footer';
import Loader from './pages/Loader';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from '@fortawesome/free-solid-svg-icons';
import logo from './prlogo.svg'; // Adjust the path as necessary
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const SizeSetInspection = lazy(() => import("./pages/SizeSetInspection"));
const ConquestConsulting = lazy(() => import("./pages/ConquestConsulting"));
const TrainingConsulting = lazy(() => import("./pages/trainingConsulting"));
const OurCoreInspectionService = lazy(() => import("./pages/ourCoreInspectionService"));
const Sedex = lazy(() => import("./pages/Sedex"));
const Amfori = lazy(() => import("./pages/Amfori"));
const SocialLabourComplianceProgram = lazy(() => import("./pages/SocialLabourComplianceProgram"));
const HiggIndexConsulting = lazy(() => import("./pages/HiggIndexConsulting"));
const GlobalOrganicTextileStandards = lazy(() => import("./pages/GlobalOrganicTextileStandards"));
const GlobalRecycledStandard = lazy(() => import("./pages/GlobalRecycledStandard"));
const TechnicalAuditsforGlobalBrands = lazy(() => import("./pages/TechnicalAuditsforGlobalBrands"));
const BrandSocial = lazy(() => import("./pages/brandSocial"));

const PreProduction = lazy(() => import("./pages/PreProduction"));
const CutPanelInspection = lazy(() => import("./pages/CutPanelInspection"));
const InLineInspection = lazy(() => import("./pages/InLineInspection"));
const CheckedPiecesInspection = lazy(() => import("./pages/CheckedPiecesInspection"));
const FinalRandomInspection = lazy(() => import("./pages/FinalRandomInspection"));



function App() {
   const [isOpen, setIsOpen] = useState(false);
const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const toggleSubMenu = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
  };
  const toggleMenu = () => setIsOpen(!isOpen);
   const closeMenu = () => setIsOpen(false);
     const headerRef = useRef(null);
      useEffect(() => {
    const handleScroll = () => {
      const header = headerRef.current;
      if (window.scrollY > 0) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <Router>
      <header class="header-one header--sticky" ref={headerRef}>
        <div class="header-top-area-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="header-top-one-wrapper">
                  <div class="left">
                    <div class="mail">
                      <a href="mailto:qualityfirst@conquestasia.com">
                               <FontAwesomeIcon icon={faEnvelope}  style={{ color: 'white',marginRight:"5px" }}/>
                        qualityfirst@conquestasia.com
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <ul class="top-nav">
                      <li>
                        <a  href="tel:9865250178">
                              <FontAwesomeIcon icon={faPhone}  style={{ color: 'white',marginRight:"5px" }}/>
                            9865250178
                        </a>
                      </li>
                    
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-main">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="header-main-one-wrapper">
                  {/* Logo */}
                  <div className="thumbnail">
                    <Link to="/">
                      <img
                        src={logo}
                        alt="finbiz-logo"
                        className="logo-width"
                      />
                    </Link>
                  </div>

                  {/* Hamburger Button */}
                  <div className="mobile-menu-icon" onClick={toggleMenu}>
                    <FontAwesomeIcon
                      icon={isOpen ? faTimes : faBars}
                      size="lg"
                    />
                  </div>

                  {/* Overlay */}
                  {isOpen && (
                    <div className="overlay" onClick={closeMenu}></div>
                  )}

                  {/* Nav Menu */}
                  <nav className={`main-header ${isOpen ? "active" : ""}`}>
                    <ul>
                      <li className="main-nav mega-menu">
                        <Link to="/" onClick={closeMenu}>
                          Home
                        </Link>
                      </li>

                      <li className="main-nav mega-menu">
                        <Link to="/about" onClick={closeMenu}>
                          About
                        </Link>
                      </li>

                      <li className="main-nav has-dropdown project-a-after">
                        <Link onClick={toggleSubMenu}>
                          Services{" "}
                          <FontAwesomeIcon
                            icon={faAngleDown}
                            style={{ marginLeft: "6px" }}
                          />
                        </Link>
                        <ul className="submenu parent-nav desktop-submenu">
                            <li>
                              <Link
                                to="/ourCoreInspectionService"
                                onClick={toggleSubMenu}
                              >
                                Our Core Inspection Services
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/trainingConsulting"
                                onClick={toggleSubMenu}
                              >
                                Consultancy
                              </Link>
                            </li>
                          </ul>
                        {isSubMenuOpen && (
                          <ul className=" parent-nav mobile-submenu">
                            <li>
                              <Link
                                to="/ourCoreInspectionService"
                             onClick={() => {
    toggleSubMenu();
    closeMenu();
  }}
                              >
                                Our Core Inspection Services
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/trainingConsulting"
                              onClick={() => {
    toggleSubMenu();
    closeMenu();
  }}
                              >
                                Consultancy
                              </Link>
                            </li>
                          </ul>
                        )}
                      </li>

                      <li className="main-nav mega-menu">
                        <Link to="/contact" onClick={closeMenu}>
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/SizeSetInspection" element={<SizeSetInspection />} />
          <Route path="/ConquestConsulting" element={<ConquestConsulting />} />
          <Route path="/PreProduction" element={<PreProduction />} />
          <Route path="/CutPanelInspection" element={<CutPanelInspection />} />
          <Route path="/InLineInspection" element={<InLineInspection />} />
          <Route path="/trainingConsulting" element={<TrainingConsulting />} />
          <Route
            path="/ourCoreInspectionService"
            element={<OurCoreInspectionService />}
          />
          <Route path="/Amfori" element={<Amfori />} />
          <Route path="/Sedex" element={<Sedex />} />
          <Route
            path="/SocialLabourComplianceProgram"
            element={<SocialLabourComplianceProgram />}
          />
          <Route
            path="/GlobalOrganicTextileStandards"
            element={<GlobalOrganicTextileStandards />}
          />
          <Route
            path="/GlobalRecycledStandard"
            element={<GlobalRecycledStandard />}
          />
          <Route
            path="/HiggIndexConsulting"
            element={<HiggIndexConsulting />}
          />
          <Route
            path="/CheckedPiecesInspection"
            element={<CheckedPiecesInspection />}
          />
          <Route path="/brandSocial" element={<BrandSocial />} />
          <Route
            path="/TechnicalAuditsforGlobalBrands"
            element={<TechnicalAuditsforGlobalBrands />}
          />
          <Route
            path="/FinalRandomInspection"
            element={<FinalRandomInspection />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <Footer />
    </Router>
  );
}

export default App;
